import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { resetPassword } from '../bridge';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';

const logo = require('../logo.jpeg');

const PasswordReset = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { login } = useAuth();
  const email = state?.email || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    const ok = await resetPassword(email, newPassword);
    setLoading(false);
    if (!ok) {
      setError('Something went wrong. Please try again.');
      return;
    }
    login(email);
    navigate('/manage', { replace: true });
  };

  return (
    <div className="auth-page">
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <img src={logo} className="navbar-logo" alt="Menu & Catalog Maker" />
            <span className="navbar-title">Menu &amp; Catalog Maker</span>
          </Link>
        </div>
      </nav>

      <div className="auth-body">
        <div className="auth-card">
          <h1 className="auth-card-title">Set a new password</h1>
          <p className="auth-card-subtitle">
            Choose a new password for <strong>{email}</strong>.
          </p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label className="auth-label">New password</label>
              <input
                className="auth-input"
                type="password"
                placeholder="Min. 8 characters"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                autoComplete="new-password"
              />
            </div>
            <div className="auth-field">
              <label className="auth-label">Confirm password</label>
              <input
                className="auth-input"
                type="password"
                placeholder="Repeat your password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
              />
            </div>
            <button className="auth-submit" type="submit" disabled={loading}>
              {loading ? 'Saving…' : 'Save and log in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
